module.exports = __webpack_public_path__ + "static/images/p-sysx.4d4891b.png";